<template>
  <div>
    <img 
      v-if="current==0"
      src="../../../assets/btn/1-tri_on.png" width="40" height="40" />
    <img 
      v-else
      src="../../../assets/rhythm.png" width="40" height="40" />
  </div>
</template>

<script>
export default {
  name: 'mode_switch',
  props: {
    current: {type: Number, required: true}
  }
}
</script>